import React, { Children, memo } from 'react';
import { MapPinIcon, MailIcon, ExternalLinkIcon, HeartHandshakeIcon, NavigationIcon, CopyIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 24
    }
  }
};
export function InfoPage() {
  const copyEmail = () => {
    navigator.clipboard.writeText('mgreal@admlead.com');
    // In a real app, show a toast here
  };
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-81">
      {/* Venue Header Image */}
      <div className="relative h-56 w-full overflow-hidden rounded-b-[2rem] shadow-lg" data-id="element-82">
        <motion.div initial={{
        scale: 1.1
      }} animate={{
        scale: 1
      }} transition={{
        duration: 1.5
      }} className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/nnuu339Nvnant8LEhh5SUa/Screenshot_2025-12-30_112204.png")'
      }} data-id="element-83" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" data-id="element-84" />
        <div className="absolute bottom-0 left-0 p-8 w-full" data-id="element-85">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl font-black text-white drop-shadow-lg" data-id="element-86">
            Conference Info
          </motion.h1>
        </div>
      </div>

      <motion.div variants={containerVariants} initial="hidden" animate="show" className="px-6 py-8 space-y-8" data-id="element-87">
        {/* Venue Details */}
        <motion.section variants={itemVariants} className="bg-white rounded-3xl p-6 shadow-xl shadow-gray-200/50 border border-gray-100 relative overflow-hidden" data-id="element-88">
          <div className="absolute top-0 right-0 w-32 h-32 bg-purple-50 rounded-bl-full -z-0" data-id="element-89" />

          <h2 className="text-xl font-black text-[#7B2D8E] mb-5 flex items-center relative z-10" data-id="element-90">
            <MapPinIcon className="w-6 h-6 mr-3 text-[#D4A017]" data-id="element-91" />
            Venue Location
          </h2>

          <div className="space-y-5 relative z-10" data-id="element-92">
            <div data-id="element-93">
              <p className="font-black text-xl text-gray-900 mb-1" data-id="element-94">
                Spirit of Excellence Church (UIC)
              </p>
              <p className="text-gray-600 font-medium text-lg" data-id="element-95">
                9 County Road 287
                <br data-id="element-96" />
                Oxford, MS 38655
              </p>
            </div>

            <a href="https://www.google.com/maps/search/?api=1&query=9+County+Road+287+Oxford+MS+38655" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full py-3 px-4 bg-gray-100 text-gray-900 rounded-xl font-bold hover:bg-gray-200 transition-colors" data-id="element-97">
              <NavigationIcon className="w-5 h-5 mr-2 text-[#7B2D8E]" data-id="element-98" />
              Get Directions
            </a>

            <div className="pt-5 border-t border-gray-100 flex items-center justify-between" data-id="element-99">
              <div className="flex items-center text-[#7B2D8E]" data-id="element-100">
                <MailIcon className="w-5 h-5 mr-3" data-id="element-101" />
                <a href="mailto:mgreal@admlead.com" className="font-bold text-lg hover:underline" data-id="element-102">
                  mgreal@admlead.com
                </a>
              </div>
              <button onClick={copyEmail} className="p-2 bg-purple-50 rounded-lg text-[#7B2D8E] hover:bg-purple-100 transition-colors" data-id="element-103">
                <CopyIcon className="w-5 h-5" data-id="element-104" />
              </button>
            </div>
          </div>
        </motion.section>

        <div className="flex items-center justify-center gap-4 py-2" data-id="element-105">
          <div className="h-px bg-gray-300 flex-1" data-id="element-106" />
          <HeartHandshakeIcon className="w-6 h-6 text-gray-400" data-id="element-107" />
          <div className="h-px bg-gray-300 flex-1" data-id="element-108" />
        </div>

        {/* Sponsorship */}
        <motion.section variants={itemVariants} data-id="element-109">
          <div className="bg-gradient-to-r from-[#D4A017] to-[#F3C642] rounded-t-3xl p-5 text-center shadow-lg relative z-10" data-id="element-110">
            <h2 className="text-2xl font-black text-white flex items-center justify-center drop-shadow-md" data-id="element-111">
              <HeartHandshakeIcon className="w-7 h-7 mr-3" data-id="element-112" />
              Consider Sponsorship
            </h2>
          </div>

          <div className="bg-gradient-to-b from-[#7B2D8E] to-[#4a1459] rounded-b-3xl p-6 space-y-5 shadow-xl -mt-2 pt-8" data-id="element-113">
            {/* Featured Tier */}
            <div className="bg-white rounded-2xl p-5 border-2 border-[#D4A017] shadow-[0_0_20px_rgba(212,160,23,0.3)] relative transform scale-[1.02] z-10" data-id="element-114">
              <div className="absolute -top-3 right-4 bg-[#D4A017] text-white text-xs font-black px-3 py-1 rounded-full uppercase tracking-wider shadow-md" data-id="element-115">
                Best Value
              </div>
              <h3 className="text-[#7B2D8E] font-black text-xl mb-2" data-id="element-116">
                Nehemiah Sponsor - $200
              </h3>
              <p className="text-gray-700 font-medium leading-relaxed" data-id="element-117">
                Primary recognition across event platforms, verbal
                acknowledgment, promotional material inclusion, and one
                complimentary registration.
              </p>
            </div>

            {/* Other Tiers */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/20 hover:bg-white/15 transition-colors" data-id="element-118">
              <h3 className="text-[#D4A017] font-black text-lg mb-2" data-id="element-119">
                Barnabas Sponsor - $100
              </h3>
              <p className="text-purple-100 text-sm leading-relaxed font-medium" data-id="element-120">
                Recognition in the conference program and on the Men Getting
                Real Conference website.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/20 hover:bg-white/15 transition-colors" data-id="element-121">
              <h3 className="text-[#D4A017] font-black text-lg mb-2" data-id="element-122">
                Andrew Sponsor - $50
              </h3>
              <p className="text-purple-100 text-sm leading-relaxed font-medium" data-id="element-123">
                Your name listed on the Men Getting Real Conference website.
              </p>
            </div>
          </div>
        </motion.section>

        {/* Submission Options */}
        <motion.section variants={itemVariants} className="bg-white rounded-3xl p-6 shadow-xl shadow-gray-200/50 border border-gray-100" data-id="element-124">
          <h2 className="text-xl font-black text-gray-900 mb-5" data-id="element-125">
            Submission Options
          </h2>

          <div className="space-y-4" data-id="element-126">
            <div className="p-5 bg-purple-50 rounded-2xl border border-purple-100" data-id="element-127">
              <h3 className="font-black text-[#7B2D8E] text-lg mb-3" data-id="element-128">
                Option 1: Pay Online
              </h3>
              <a href="https://cme.sh/MGRGIVE" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full py-3.5 px-4 bg-[#7B2D8E] text-white rounded-xl font-bold hover:bg-[#632472] transition-colors shadow-md" data-id="element-129">
                Give via Givelify
                <ExternalLinkIcon className="w-5 h-5 ml-2" data-id="element-130" />
              </a>
              <p className="text-sm text-purple-800/70 mt-3 text-center font-medium" data-id="element-131">
                Note: Add "2026 Men Getting Real Conference - SPONSOR GIFT"
              </p>
            </div>

            <div className="p-5 bg-gray-50 rounded-2xl border border-gray-200" data-id="element-132">
              <h3 className="font-black text-gray-900 text-lg mb-3" data-id="element-133">
                Option 2: Mail a Check
              </h3>
              <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm" data-id="element-134">
                <p className="text-gray-800 space-y-1.5 font-medium" data-id="element-135">
                  <span className="block text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-136">
                    Payable to:
                  </span>
                  <span className="block text-lg" data-id="element-137">
                    Spirit of Excellence Church
                  </span>
                  <span className="block mt-3 text-sm text-gray-500 uppercase tracking-wider font-bold" data-id="element-138">
                    Mail to:
                  </span>
                  <span className="block" data-id="element-139">9 County Road 287</span>
                  <span className="block" data-id="element-140">Oxford, MS 38655</span>
                </p>
              </div>
              <p className="text-sm text-gray-500 mt-3 text-center font-medium" data-id="element-141">
                Note: Add "2026 MGR Conference - SPONSOR GIFT" to memo
              </p>
            </div>
          </div>
        </motion.section>

        {/* Final CTA */}
        <motion.div variants={itemVariants} className="pt-4 pb-8" data-id="element-142">
          <a href="https://share.deftform.com/bJaXH8" target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center py-5 px-6 bg-gradient-to-r from-[#D4A017] to-[#F3C642] text-[#7B2D8E] rounded-2xl font-black text-xl shadow-xl shadow-amber-500/20 hover:shadow-amber-500/40 transition-all active:scale-[0.98]" data-id="element-143">
            Register Now
            <ExternalLinkIcon className="w-6 h-6 ml-3" data-id="element-144" />
          </a>
        </motion.div>
      </motion.div>
    </div>;
}